import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  Filter,
  SearchInput,
  SelectInput,
  TopToolbar,
  ExportButton,
  NumberField,

  ChipField,
  FunctionField,
} from 'react-admin';

const orderStatusChoices = [
  { id: 'PENDING', name: 'Ожидает' },
  { id: 'PROCESSING', name: 'Обрабатывается' },
  { id: 'SHIPPED', name: 'Отправлен' },
  { id: 'DELIVERED', name: 'Доставлен' },
  { id: 'CANCELLED', name: 'Отменен' },
];

const OrderFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="status"
      choices={orderStatusChoices}
      label="Статус"
    />
    <SelectInput
      source="isPaid"
      choices={[
        { id: true, name: 'Оплачен' },
        { id: false, name: 'Не оплачен' },
      ]}
      label="Статус оплаты"
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <ExportButton />
  </TopToolbar>
);

const StatusChip = ({ record }: any) => {
  if (!record || !record.status) return <span>-</span>;
  const statusChoice = orderStatusChoices.find(choice => choice.id === record.status);
  const getColor = (status: string) => {
    switch (status) {
      case 'PENDING': return 'warning';
      case 'PROCESSING': return 'info';
      case 'SHIPPED': return 'primary';
      case 'DELIVERED': return 'success';
      case 'CANCELLED': return 'error';
      default: return 'default';
    }
  };
  
  return (
    <ChipField 
      record={{ value: statusChoice?.name || record.status }} 
      source="value" 
      color={getColor(record.status)}
    />
  );
};


export const OrderList = () => (
  <List
    filters={<OrderFilter />}
    actions={<ListActions />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid>
      <TextField source="id" label="ID заказа" />
      
      {/* Клиент */}
      <TextField source="user.name" label="Клиент" />
      <TextField source="user.email" label="Email клиента" />
      
      {/* Продукт */}
      <TextField source="supplement.name" label="Добавка" />
      <TextField source="supplement.emoji" label="🏷️" />
      
      {/* Детали заказа */}
      <NumberField source="quantity" label="Количество" />
      <FunctionField 
        label="Общая сумма"
        render={(record: any) => `$${record.totalPrice?.toFixed(2) || '0.00'}`}
      />
      
      {/* Статусы */}
      <FunctionField 
        label="Статус"
        render={(record: any) => <StatusChip record={record} />}
      />
      <BooleanField source="isPaid" label="Оплачен" />
      
      {/* Контекст */}
      <TextField source="challengeContext" label="Контекст челленджа" />
      <TextField source="recommendationReason" label="Причина рекомендации" />
      
      {/* Даты */}
      <DateField source="createdAt" label="Дата создания" />
      <DateField source="paidAt" label="Дата оплаты" />
      
      <EditButton />
      <ShowButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
